import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { DashBoardFaturamento } from '../domain/dashboard-faturamento';

export class DashBoardFaturamentoSerializer extends DomainSerializer<DashBoardFaturamento> {}
